import React from "react";
import { useState } from "react";
import logo from "../assets/logo.jpeg";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="relative bg-primary text-white pt-16 pb-8 overflow-hidden">
        {/* Decorative Background */}
        <div className="absolute -top-10 -left-10 w-40 h-40 bg-accent/20 rounded-full blur-3xl animate-pulse -z-10"></div>
        <div className="absolute -bottom-10 -right-10 w-48 h-48 bg-accent/10 rounded-full blur-3xl animate-ping -z-10"></div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row md:justify-between gap-12">
          {/* Column 1: Logo & Branding */}
          <div className="flex flex-col items-start">
            {/* Logo */}
            <div className="h-16 w-16 rounded-full bg-gradient-to-tr from-accent to-[#f9a634] flex items-center justify-center shadow-lg mb-4">
             
             <Link to="/login/admin"> <img
                src={logo}
                alt="Jeeva Shakthi Logo"
                className="rounded-full object-cover drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]"
              />
              </Link>
            </div>

            {/* Main Title */}
            <h1 className="text-xl md:text-2xl font-bold tracking-wide">
              JEEVA SHAKTHI HOUSING
            </h1>
            <p className="text-xs md:text-sm text-[#F9B208] font-semibold tracking-wider uppercase">
              Multistate Cooperative Society Ltd
            </p>
            <p className="mt-3 text-xs md:text-sm text-[#ffffff] font-semibold">
              Empowering Communities through Affordable Housing
            </p>
            {/* Social Icons */}
            <div className="flex mt-4 space-x-4">
              {[
                { icon: "facebook", link: "#" },
                { icon: "twitter", link: "#" },
                { icon: "instagram", link: "#" },
                { icon: "linkedin", link: "#" },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-accent/20 hover:bg-accent transition-colors"
                >
                  {/* Use SVG icons to avoid external dependencies */}
                  {social.icon === "facebook" && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M22.675 0h-21.35C.597 0 0 .593 0 1.326v21.348C0 23.407.597 24 1.326 24h11.495v-9.294H9.691v-3.622h3.13V8.41c0-3.1 1.893-4.788 4.658-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.763v2.312h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.324-.593 1.324-1.326V1.326C24 .593 23.405 0 22.675 0z" />
                    </svg>
                  )}
                  {social.icon === "twitter" && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M24 4.557a9.828 9.828 0 0 1-2.828.775 4.932 4.932 0 0 0 2.165-2.724 9.865 9.865 0 0 1-3.127 1.195 4.916 4.916 0 0 0-8.38 4.482A13.944 13.944 0 0 1 1.671 3.149a4.916 4.916 0 0 0 1.523 6.574 4.897 4.897 0 0 1-2.229-.616c-.054 2.281 1.581 4.415 3.949 4.89a4.902 4.902 0 0 1-2.224.084 4.917 4.917 0 0 0 4.59 3.417 9.867 9.867 0 0 1-6.102 2.104c-.396 0-.788-.023-1.177-.069a13.945 13.945 0 0 0 7.557 2.212c9.054 0 14.002-7.496 14.002-13.986 0-.213-.004-.425-.014-.637A10.025 10.025 0 0 0 24 4.557z" />
                    </svg>
                  )}
                  {social.icon === "instagram" && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.054 1.97.24 2.428.512a4.92 4.92 0 0 1 1.787 1.787c.272.458.458 1.257.512 2.428.058 1.266.07 1.645.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.24 1.97-.512 2.428a4.922 4.922 0 0 1-1.787 1.787c-.458.272-1.257.458-2.428.512-1.266.058-1.645.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.97-.24-2.428-.512a4.922 4.922 0 0 1-1.787-1.787c-.272-.458-.458-1.257-.512-2.428C2.175 15.747 2.163 15.368 2.163 12s.012-3.584.07-4.85c.054-1.17.24-1.97.512-2.428A4.922 4.922 0 0 1 4.532 2.935c.458-.272 1.257-.458 2.428-.512C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.014 7.052.072 5.78.13 4.845.345 4.042.678a7.074 7.074 0 0 0-2.6 1.69 7.072 7.072 0 0 0-1.69 2.6c-.333.803-.548 1.738-.606 3.01C-.014 8.332 0 8.741 0 12c0 3.259.014 3.668.072 4.948.058 1.272.273 2.207.606 3.01a7.072 7.072 0 0 0 1.69 2.6 7.074 7.074 0 0 0 2.6 1.69c.803.333 1.738.548 3.01.606C8.332 23.986 8.741 24 12 24s3.668-.014 4.948-.072c1.272-.058 2.207-.273 3.01-.606a7.072 7.072 0 0 0 2.6-1.69 7.074 7.074 0 0 0 1.69-2.6c.333-.803.548-1.738.606-3.01.058-1.28.072-1.689.072-4.948s-.014-3.668-.072-4.948c-.058-1.272-.273-2.207-.606-3.01a7.074 7.074 0 0 0-1.69-2.6 7.072 7.072 0 0 0-2.6-1.69c-.803-.333-1.738-.548-3.01-.606C15.668.014 15.259 0 12 0z" />
                      <path d="M12 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998z" />
                      <circle cx="18.406" cy="5.594" r="1.44" />
                    </svg>
                  )}
                  {social.icon === "linkedin" && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M22.23 0H1.77C.792 0 0 .774 0 1.728v20.543C0 23.226.792 24 1.77 24h20.46c.978 0 1.77-.774 1.77-1.728V1.728C24 .774 23.208 0 22.23 0zM7.061 20.452H3.539V9h3.522v11.452zM5.3 7.574a2.038 2.038 0 1 1 0-4.076 2.038 2.038 0 0 1 0 4.076zM20.452 20.452h-3.522v-5.569c0-1.328-.025-3.037-1.85-3.037-1.853 0-2.136 1.446-2.136 2.938v5.668h-3.522V9h3.38v1.561h.048c.47-.888 1.618-1.82 3.33-1.82 3.556 0 4.212 2.34 4.212 5.384v6.867z" />
                    </svg>
                  )}
                </a>
              ))}
            </div>

            {/* Small Tagline */}
          </div>

          {/* Column 2: Quick Links */}
         {/* Column 2: Quick Links */}
<div className="flex flex-col">
  <h3 className="text-accent text-lg font-bold mb-4">Quick Links</h3>
  <ul className="space-y-2 text-sm font-semibold">

    <li>
      <a href="/#aboutus" className="hover:text-accent transition-colors font-semibold">
        About Us
      </a>
    </li>

    <li>
      <a href="/#aboutus" className="hover:text-accent transition-colors font-semibold">
        Mission and Vision
      </a>
    </li>

    <li>
      <a href="/#affordablehousingadvantage" className="hover:text-accent transition-colors font-semibold">
        Affordable Housing Advantage
      </a>
    </li>

    <li>
      <a href="/#ministry" className="hover:text-accent transition-colors font-semibold">
        Ministry
      </a>
    </li>

    <li>
      <a href="/#leadership" className="hover:text-accent transition-colors font-semibold">
        Our Leadership
      </a>
    </li>

    <li>
      <a href="/#ourgallery" className="hover:text-accent transition-colors font-semibold">
        Our Gallery
      </a>
    </li>

    <li>
      <a
        href="../gallery/Jeeva Sakthi Housing Multistate Industrial Cooperative Society Ltd By Laws.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-accent transition-colors font-semibold"
      >
        By Laws
      </a>
    </li>

  </ul>
</div>


          {/* Column 3: Government Schemes */}
          <div className="flex flex-col">
            <h3 className="text-accent text-lg font-bold mb-4">
              Government Schemes
            </h3>
            <ul className="space-y-2 text-sm font-semibold">
              {["PMAY", "PM Surya Ghar: Muft Bijli Yojana"].map((scheme) => (
                <li key={scheme}>
                  <a
                    href={`/#governmentschemes`}
                    className="hover:text-accent transition-colors font-semibold"
                  >
                    {scheme}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact & Social */}
          <div className="flex flex-col">
            <h3 className="text-accent text-lg font-bold mb-4">Contact</h3>
            <p className="text-sm font-semibold">
              Email:{" "}
              <a
                href="mailto:info@gmail.com"
                className="hover:text-accent transition-colors"
              >
                jshmcsl@zoho.com
              </a>
            </p>
            <p className="text-sm font-semibold mt-2">
              Phone:{" "}
              <a
                href="tel:+919894624576"
                className="hover:text-accent transition-colors"
              >
                +91 98946 24576
              </a>
            </p>

            <p className="text-sm font-semibold mt-2">
              Address: No. 1, Bazar Street, Manamathi, <br /> Chengalpattu
              District, Tamil Nadu- 603105
            </p>
          </div>
        </div>

        <div className="mt-12 border-t border-accent/30 pt-6 text-center text-gray-200">
          <p className="text-sm md:text-base font-semibold">
            &copy; {new Date().getFullYear()} Jeeva Shakthi Housing Multistate
            Cooperative Society Ltd. All rights reserved.
          </p>
          <p className="text-xs md:text-sm font-medium mt-1">
            Developed by{" "}
            <span className="text-accent font-semibold">
              <a href="https://alizesoftwareservices.com/">
                Alize Software Services LLP
              </a>
            </span>
          </p>
        </div>
      </footer>
    </>
  );
};
export default Footer;
